import type { AxiosResponse } from 'axios'
import axios from 'axios'
import { create } from 'zustand'

type AuthState = {
  loading: boolean
  token: string | null
  logout: () => void
}

export const useAuthState = create<AuthState>(set => ({
  loading: true,
  token: null,

  logout: () => {
    localStorage.removeItem('token')
    set({ token: null })
  },
}))

export const initAuthState = () => {
  const url = new URL(window.location.href)
  const tokenFromUrl = url.searchParams.get('token')

  if (tokenFromUrl) {
    localStorage.setItem('token', tokenFromUrl)
    url.searchParams.delete('token')
    window.history.replaceState({}, '', url.toString())
    useAuthState.setState({
      loading: false,
      token: tokenFromUrl,
    })
    return
  }

  const tokenFromStorage = localStorage.getItem('token')
  useAuthState.setState({
    loading: false,
    token: tokenFromStorage,
  })
}

export async function auth<T>(
  request: (token: string) => Promise<AxiosResponse<T>>,
): Promise<AxiosResponse<T>> {
  const { token, logout } = useAuthState.getState()

  if (!token) {
    logout()
    throw new Error('No token')
  }

  try {
    return await request(token)
  }
  catch (err) {
    if (axios.isAxiosError(err)) {
      const status = err.response?.status
      if (status === 401) logout()
    }
    throw err
  }
}
